import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import {
  ACCOUNT_TAB,
  ADS_TAB,
  TransactionTabType,
} from '../../Transactions.constants';
import * as S from './TransactionsTabs.styles';
import { ROUTES } from '@/constants/routes';

interface TransactionsTabsProps {
  activeTab: TransactionTabType;
}

const TAB_ROUTES: Record<TransactionTabType, string> = {
  [ADS_TAB]: ROUTES.adsTxs,
  [ACCOUNT_TAB]: ROUTES.accountTxs,
};

export function TransactionsTabs({ activeTab }: TransactionsTabsProps) {
  const { t } = useTranslation();
  const router = useRouter();

  function handleTabClick(tab: TransactionTabType) {
    router.replace(TAB_ROUTES[tab]);
  }

  return (
    <S.Container>
      <S.Tab
        type="button"
        $isActive={activeTab === ACCOUNT_TAB}
        onClick={() => handleTabClick(ACCOUNT_TAB)}
      >
        {t('pages.cabinet.private_account')}
      </S.Tab>
      <S.Tab
        type="button"
        $isActive={activeTab === ADS_TAB}
        onClick={() => handleTabClick(ADS_TAB)}
      >
        {t('pages.cabinet.ads')}
      </S.Tab>
    </S.Container>
  );
}
